export function useModalControls() {
  const mountArchivedLevelsModal = ref(false);
  const isShowArchivedLevelsModal = ref(false);

  function showArchivedLevelsModal() {
    !mountArchivedLevelsModal.value && (mountArchivedLevelsModal.value = true);
    isShowArchivedLevelsModal.value = true;
  }

  return {
    mountArchivedLevelsModal,
    isShowArchivedLevelsModal,
    showArchivedLevelsModal
  };
}